/**
 * 门户文本默认配置数据
 */
export const home = [{}]

/**
 * 大屏文本默认配置数据
 */
export const bs = [
    {
      codeColor: "rgba(255,255,255,1)"
    }
]

/**
 * app状态标签默认配置数据
 */
export const appHome = [{}]
